/**
 * Footer Component
 * Simple footer with copyright info
 */

import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Footer component
 */
export function Footer() {
  const { t } = useTranslation('common');
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <p className="text-sm text-gray-500 text-center">
          {t('footer.copyright', { year: currentYear })}
        </p>
      </div>
    </footer>
  );
}
